<template lang="pug">
    thead
        component(:is="item.component", :contents="item.contents", v-for="item, index in mappedComponents", :key="`${item.type}-${index}`")
</template>

<script>
import { tableComponents as components, tableDictionary, props } from '@/mixins/component'

export default {
    name: "component-tabela-cabecalho",
    props,
    components,
    computed: {
        mappedComponents() {
            return this.contents.content.map(item => {
                return { component: this.$options.components[tableDictionary[item.type]], contents: item, type: item.type }
            })
        },
    }
}
</script>

<style lang="stylus" scoped src="./TabelaCabecalho.styl"></style>